import { useAppSelector } from 'reduxTyped'

import { useViewPayload } from 'apps/aiAutomation/hooks/layout'
import { SidebarViewType } from 'apps/aiAutomation/lib/sidebar'
import { AiAutomationEngagementGoalSelectors } from 'apps/aiAutomation/store/engagementGoal'
import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

export const useSelectedGoalData = () => {
  const payload = useViewPayload(SidebarViewType.ENGAGEMENT_GOAL_EDITOR)

  const goal = useAppSelector((state) =>
    payload?.goalId ? AiAutomationEngagementGoalSelectors.getItemById(state, payload.goalId) : null,
  )
  const goalId = payload?.goalId ?? null

  return {
    selectedGoal: goal,
    selectedGoalId: goalId,
    goalType: goal?.type ?? payload?.goalType ?? GoalType.LEAD_GEN,
  }
}
